import {
  MeetingsValue,
  TSpeakerContent,
} from "../../../services/api/instances/meetingsApi/types";

export const MEETING_INITIAL_VALUE: MeetingsValue = {
  meetings_object: {
    recognize_hash: null,
    meeting_info: {
      meeting_name: null,
      meeting_date: null,
      meeting_description: null,
      _user_edited: false,
    },
    meta: {
      progress: null,
      estimate_duration: null,
      status: "init",
    },
    transcription: [],
    thread_ref: null,
    final_result: null,
    llm_selection: {
      assistant_ref: null,
      model: "gpt-4o",
    },
  },
};

export const ACCEPTABLE_FILE_EXTENSIONS = ["mp3", "wav", "flac", "aiff", "ogg"];

export const SPEAKER_UNDEFINED = "SPEAKER_UNDEFINED";

export const CUSTOM_SPEAKER_NAME = "CUSTOM_SPEAKER_0";

export const INITIAL_SPEECH_OBJECT: TSpeakerContent = {
  id: "",
  speaker_group_key: SPEAKER_UNDEFINED,
  speaker_name: "",
  speech_content: "",
  isActive: false,
  time_code: "",
};

export const MEETING_META_INSTRUCTION =
  "Всё что находиться внутри этого тега нужно анализировать и использовать для ответа. Не упоминай название тега в ответах. Everything inside this tag should be analyzed and used in your response. Don't mention the tag name in your responses.";
